
import React from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';

import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import AccountCircleIcon from 'material-ui/svg-icons/action/account-circle';
import Divider from 'material-ui/Divider';
import ListItem from 'material-ui/List/ListItem';

import HubAvatar from '../HubAvatar';

const TopRightMenu = ({ onUpdatePasswordClicked }) => {

  const signOut = () => firebase.auth().signOut();
  const { displayName, email, photoURL, providerData } = firebase.auth().currentUser;
  const showChangePasswordButton = (providerData && providerData[0] && providerData[0].providerId === "password");
  const iconStyle = {color: 'rgba(0,0,0,.74)',};

  return (
    <IconMenu
      iconButtonElement={
        <IconButton iconStyle={iconStyle}><AccountCircleIcon /></IconButton>
      }
      targetOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <ListItem
        disabled={true}
        leftAvatar={
          <HubAvatar src={photoURL} />
        }
        primaryText={displayName}
        secondaryText={email}
      />
      <Divider/>
      {showChangePasswordButton && <MenuItem primaryText="Change password" onClick={onUpdatePasswordClicked} />}
      {/* <MenuItem primaryText="Help" disabled={true} /> */}
      <MenuItem primaryText="Sign out" onClick={signOut} />
    </IconMenu>
  )
}

TopRightMenu.propTypes = {
  onUpdatePasswordClicked: PropTypes.func.isRequired,
}

export default TopRightMenu;



// WEBPACK FOOTER //
// ./src/components/ApplicationBar/TopRightMenu.jsx